import { render, staticRenderFns } from "./client_datas.vue?vue&type=template&id=6a515c3e&scoped=true"
import script from "./client_datas.vue?vue&type=script&lang=js"
export * from "./client_datas.vue?vue&type=script&lang=js"
import style0 from "./client_datas.vue?vue&type=style&index=0&id=6a515c3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a515c3e",
  null
  
)

export default component.exports